import React, { Component } from 'react';
import InfoTaskVariables from './InfoTaskVariables';
import './InfoNewModules.css';
import 'FielderUtils/style.css';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import CloseIcon from '@mui/icons-material/Close';

class InfoTaskVariablesModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: props.showModal,
    };
  }
  handleClose = () => {
    this.props.closeModal();
  };
  render() {
    const { lan } = this.props;
    return (
      <React.Fragment>
        <Dialog
          open={this.state.showModal}
          onClose={this.handleClose}
          fullWidth
          maxWidth="md"
          className="Fielder-modals-header-border Fielder-modals-content-border"
          sx={{ '& .MuiDialog-paper': { zIndex: 1000 } }}
        >
          <DialogTitle className="Fielder-modals-create-edit-detail-header-border">
            <Grid container alignItems="center">
              <Grid size>
                <div className="col ml-3 mt-3">{lan.routeTaskVariables.toUpperCase()}</div>
              </Grid>
              <Grid size="auto">
                <IconButton onClick={this.handleClose} aria-label="close">
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          </DialogTitle>

          <DialogContent>
            <Grid container justifyContent="center">
              <Grid size={12}>
                <InfoTaskVariables {...this.props} />

                {/* Save and Cancel Buttons */}
                <Grid container justifyContent="center">
                  <Grid size={{ xs: 12, sm: 6 }} className="mx-auto mt-5">
                    <button
                      className="popup-footer-btn Fielder-button"
                      onClick={this.props.closeModal}
                    >
                      {lan.continue}
                    </button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
export default InfoTaskVariablesModal;

//Original code:
/*import React, { Component } from 'react';
import InfoTaskVariables from './InfoTaskVariables';
import './InfoNewModules.css';
const _ = require('lodash');

class InfoTaskVariablesModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showModal: props.showModal,
		};
	}
	handleClose=()=> {
		this.props.closeModal();
	}
	render() {
		return (
			<React.Fragment>
				<Modal
					show={this.state.showModal}
					size={'md'}
					className='Fielder-modals-header-border Fielder-modals-content-border'
					onHide={this.handleClose}
					style={{ overlay: { zIndex: 1000 } }}
				>
					<Modal.Header className='Fielder-modals-create-edit-detail-header-border' closeButton>
						<div className='col ml-3 mt-3'>{this.props.lan.routeTaskVariables.toUpperCase()} </div>
					</Modal.Header>
					<Modal.Body>
						<Container>
							<Row className='justify-content-md-center'>
								<Col sm={12}>
									<InfoTaskVariables {...this.props} />
<Row>
  <Col sm={6} className='mx-auto mt-5'>
    <button
      className='popup-footer-btn Fielder-button'
      onClick={this.props.closeModal}
    >
      {this.props.lan.continue}
    </button>
  </Col>
</Row>
</Col>
</Row>
</Container>
</Modal.Body>
</Modal>
</React.Fragment>
);
}
}
export default InfoTaskVariablesModal;
*/
